import DecodeContacts from 'decode_contacts/scripts/decode_contacts'

$(function () {
  DecodeContacts.init()
})
